import { MINIMUM_VEHICLE_AMOUNT_VALUE } from 'formInitialValues'
import { dateIsOlderThan } from 'utils/date'
import TraversalStore from '../../stores/TraversalStore'
import { Debtor } from '../../containers/PersonalForm/PersonalForm.interface'
import { LivingSituation } from '../../interfaces/ApolloResponse.interface'
import { jobsWithoutPreviousEmployment } from '../../utils/formDependencies/statics/lists'

export const reactionClearMortgageRateUsedProperty = (
  traversal: TraversalStore,
  livingSituation: LivingSituation,
  debtor: Debtor
) => {
  if (
    livingSituation !== LivingSituation.Property &&
    traversal.data.debtors[debtor].expenses.mortgageRateUsedProperty > 0
  ) {
    traversal.handlePathFormFieldChange(
      `debtors.${debtor}.expenses.mortgageRateUsedProperty`,
      0
    )
  }
}

export const reactionUpdateHasPreviousEmployment = (
  traversal: TraversalStore,
  debtor: Debtor
) => {
  const {
    handlePathFormFieldChange,
    data: { debtors }
  } = traversal
  const { hasPreviousEmployment, currentEmployment } = debtors[debtor]
  const isJobWithoutPreviousEmployment = jobsWithoutPreviousEmployment.includes(
    currentEmployment.position
  )

  if (isJobWithoutPreviousEmployment && hasPreviousEmployment) {
    handlePathFormFieldChange(`debtors.${debtor}.hasPreviousEmployment`, false)

    return
  }

  if (!currentEmployment.since) {
    return
  }

  const isEmployedLongerThan2Years = dateIsOlderThan(currentEmployment.since, {
    year: 2
  })

  if (!isEmployedLongerThan2Years) {
    handlePathFormFieldChange(`debtors.${debtor}.hasPreviousEmployment`, true)

    return
  }

  if (hasPreviousEmployment) {
    handlePathFormFieldChange(`debtors.${debtor}.hasPreviousEmployment`, false)
  }
}

export const reactionSetAmoutVehiclePriceInitialPayment = (
  traversal: TraversalStore,
  vehiclePrice: number
) => {
  const { handlePathFormFieldChange } = traversal
  handlePathFormFieldChange(
    'common.amount',
    MINIMUM_VEHICLE_AMOUNT_VALUE,
    false
  )
  handlePathFormFieldChange(
    'common.vehicle.initialPayment',
    vehiclePrice - MINIMUM_VEHICLE_AMOUNT_VALUE,
    false
  )
}
